<template>
    <form :action="action" method="POST">
        <div class="form-group">
            <input type="hidden" name="_token" :value="token">
        </div>
        <div class="form-group">
            <input type="text" name="name" title="Name" placeholder="Name" required>
        </div>
        <div class="form-group">
            <input type="email" name="email" title="Email" placeholder="Email" required>
        </div>
        <div class="form-group">
            <textarea rows="4" name="message" title="Message" placeholder="Message" required></textarea>
        </div>
        <div class="form-group">
            <button type="submit">Submit</button>
        </div>
    </form>
</template>

<script>
import { token } from '../config'

export default {
    name: 'ContactForm',
    props: ['action'],
    data () {
        return {
            token: encodeURIComponent(window.btoa(token))
        }
    }
}
</script>

<style scoped lang="scss">
    form {
        position: relative;
        max-width: 600px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;

        .form-group {
            width: 60%;
            margin-left: auto;
            margin-right: auto;
            margin-top: 20px;

            input, textarea {
                width: 100%;
                background-color: #000;
                color: #FFF;
                border: none;
                border-bottom: 1px solid #FFF;
                outline: none;
                opacity: 0.5;
            }

            input::placeholder, textarea::placeholder {
                color: #FFF;
            }

            input:focus, textarea:focus {
                border-bottom: 2px solid #FFF;
                opacity: 1;
            }

            button {
                outline: none;
                background-color: #000;
                border: 1px solid #FFF;
                color: #fff;
                opacity: 0.5;
                padding: 10px 20px;
                cursor: pointer;
            }

            button:hover, button:focus {
                opacity: 1;
            }
        }
    }
</style>
